import { render, staticRenderFns } from "./OverlayBody.vue?vue&type=template&id=13a1d844&"
import script from "./OverlayBody.vue?vue&type=script&lang=js&"
export * from "./OverlayBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports